import React, { useState } from 'react';

const Select = (props) => {
  const [focused, setFocus] = useState();

  return (
    <div className={"form-group form-group--floating form-group--dark" + (props.value || focused ? " form-group--active" : "") }>
      <label className="form-label form-label--floating form-label--dark" htmlFor={props.id}>{props.label}</label>
      <select 
        name={props.id} id={props.id} className="form-control form-control--floating form-control--dark" 
        onChange={props.onChange} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
      >
        <option className="text-dark"></option>
        {props.options.map((option, i) =>
          <option 
            key={i} value={JSON.stringify(option)} className="text-dark"
            id={option.name.replace(/\s+/g, '')}
          >{option.name}</option>
        )}
      </select>
    </div>
  );
}

export default Select;